import React from 'react'
import PropTypes from 'prop-types'
import EducationProfileMatch from './EducationProfileMatch'
import eventTypes from '../eventTypes'
import { connect } from 'react-redux'
import { fetchEducationPayoutEvent } from '../actions'
import OnMount from './OnMount'

FetchEducationProfileFirstPayout.propTypes = {
  fetchEducationPayoutEvent: PropTypes.func.isRequired
}

function FetchEducationProfileFirstPayout({ fetchEducationPayoutEvent }) {
  return (
    <EducationProfileMatch
      withEvents={[eventTypes.FIRST_CAPTURE]}
      withoutEvents={[eventTypes.FIRST_PAYOUT]}
    >
      <OnMount callback={fetchEducationPayoutEvent} />
    </EducationProfileMatch>
  )
}

export default connect(null, { fetchEducationPayoutEvent })(FetchEducationProfileFirstPayout)
